module.exports = __webpack_public_path__ + "img/CS-Lite-Plus-User.72e418dd.jpg";